module.exports = __webpack_public_path__ + "static/logo-white-9e700a65923e06f2ffa93dcf59dd2c89.svg";